<div mat-dialog-title>
  <h2>{{ dialogTitle | translate }}</h2>
  <button class="close" (click)="dialogRef.close()" aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<mat-dialog-content>

  @if (isLoading === false) {
    @if (entityForm) {
      <form [formGroup]="entityForm" name="entityForm" novalidate>
        <!-- Form Name Field -->
        @if (displayField('title')) {
          <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field fxFlex>
              <mat-label>{{ 'activities.lesson.name' | translate }}</mat-label><input matInput name="title" formControlName="title"
              data-e2e="edit-lesson-title"
              [required]="displayRequiredField('title')">
            </mat-form-field>
          </div>
        }
        <input type="hidden" name="tagModified" formControlName="tagModified" data-e2e="edit-lesson-tag-modified">
        <!--level Field (lamorim : target age = educational level )-->
        @if (displayField('target-age') || displayField('educationalLevel')) {
          <div fxLayout="row" fxLayoutAlign="space-around center">
            <mat-form-field fxFlex="100">
              <mat-label>{{ displayField('target-age') ? ('activities.target_age' | translate) : ('generic.level' | translate) }}</mat-label><mat-select
              formControlName="educationalLevel" [required]="displayRequiredField('educationalLevel')">
              @for (level of levelsDataEntity; track level) {
                <mat-option [value]="level.id">
                  {{level.get('label')}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <!--level skill = period-->
      @if (displayField('skill')) {
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <mat-form-field fxFlex="100">
            <mat-label>{{'generic.skills' | translate }}</mat-label><mat-select  formControlName="skills" multiple [required]="displayRequiredField('skill')">
            @for (skill of skillsDataEntity; track skill) {
              <mat-option [value]="skill.id">
                {{skill.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!--  (selectionChange)="selectLearners($event)" multiple>-->
      </div>
    }
    <!--level = difficulty-->
    @if (displayField('difficulty')) {
      <div fxLayout="row" fxLayoutAlign="space-around center">
        <mat-form-field fxFlex="100">
          <mat-label>{{'generic.difficulty' | translate }}</mat-label><mat-select  formControlName="difficulty" [required]="displayRequiredField('difficulty')">
          @for (difficulty of difficultiesDataEntity; track difficulty) {
            <mat-option [value]="difficulty.id">
              {{difficulty.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <!--usage-->
  @if (displayField('usage')) {
    <div fxLayout="row" fxLayoutAlign="space-around center">
      <mat-form-field fxFlex="100">
        <mat-label>{{'generic.usage' | translate }}</mat-label><mat-select  formControlName="usage" [required]="displayRequiredField('usage')" [(value)]="storedUsage" multiple>
        @for (usage of usageDataEntity; track usage) {
          <mat-option [value]="usage.id">
            {{usage.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
<!-- assignation_type -->
@if (displayField('assignation_type')) {
  <div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-form-field fxFlex="100">
      <mat-label>{{'generic.type' | translate }}</mat-label><mat-select  formControlName="assignation_type" [required]="displayRequiredField('assignation_type')">
      @for (assignation_type of assignation_typeDataEntity; track assignation_type) {
        <mat-option [value]="assignation_type.id">
          {{ localizedType(assignation_type.attributes.label) | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}
<!-- chapters -->
@if (displayField('chapters')) {
  <div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-form-field fxFlex="100">
      <mat-label>{{'generic.chapters' | translate }}</mat-label><mat-select  formControlName="chapters" [required]="displayRequiredField('chapters')">
      @for (chapters of chaptersDataEntity; track chapters) {
        <mat-option [value]="chapters.id">
          {{chapters.label}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}
<!-- Groups field-->
@if (displayField('tags')) {
  <div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-form-field fxFlex="100">
      <mat-chip-grid #chipList>
        @for (chip of chips; track chip) {
          <mat-chip-row [selectable]="selectable" [removable]="removable"
            (removed)="remove(chip)">
            {{chip.label}}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <mat-label>{{ 'activities.lesson.tags' | translate }}</mat-label><input  [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)" data-e2e="edit-lesson-chiplist">
      </mat-chip-grid>
    </mat-form-field>
  </div>
}
<!-- Short Description Field -->
@if (displayField('description')) {
  <div fxLayout="row" fxLayoutAlign="start start">
    <mat-form-field fxFlex class="description-field">
      <mat-label>{{ 'activities.lesson.short_description' | translate }}</mat-label><textarea matInput name="description" formControlName="description" rows="10"
    [required]="displayRequiredField('description')"></textarea>
  </mat-form-field>
</div>
}
@if (displayField('source-author')) {
  <div fxLayout="row" fxLayoutAlign="start start">
    <mat-form-field fxFlex>
      <mat-label>{{ 'generic.source_author' | translate }}</mat-label><input matInput name="source-author" formControlName="source-author"
      [required]="displayRequiredField('source-author')" data-e2e="edit-lesson-source-author">
    </mat-form-field>
  </div>
}
</form>
}
<!--upload local image-->
@if (displayField('thumbnail')) {
  <div class="mat-form-field">
    <div class="mat-form-field-appearance-legacy">
      <div class="mat-form-field-wrapper">
        <div class="mat-form-field-flex">
          <div class="mat-form-field-infix">
            <span class="mat-form-field-label-wrapper">
              <label class="mat-form-field-empty mat-form-field-label">
                {{ 'generic.thumbnail' | translate }}
              </label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="center text-center">
    <span>{{ 'corpus.import_url.informations' | translate }}</span><br>
    <em><small>{{ 'corpus.import_url.details' | translate }} {{ imageUploadExtenssion }}</small></em>
    <ngx-file-drop (onFileDrop)="dropped($event, fileType.image)">
      <!--                    TODO Déprécié headertext="{{ 'corpus.upload_dragndrop_message' | translate }}"-->
      <!--                    TODO Déprécié customstyle="upload-dragndrop"-->
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <button mat-raised-button mat-primary class="add-file-button" (click)="openFileSelector()"
          aria-label="Add file">
          <span>{{ 'generic.browse' | translate }}</span>
        </button>
      </ng-template>
    </ngx-file-drop>
  </div>
  <div class="file-uploader">
    <input hidden type="file" [attr.accept]="imageUploadFormatAllowed" #fileInput
      (change)="onFileChanged($event, fileType.image)" id="fileToUpload" data-e2e="edit-lesson-file-to-upload"/>
    </div>
    <!--file thumbnail name-->
    <div class="center text-center">
      <em><small> {{ currentThumbnail | translate}}</small></em>
    </div>
    <!--alert not supported format-->
    @if (!isFileFormatAllowed) {
      <div>
        <span class="mat-error">{{'activities.thumbnail.format' | translate}}</span>
      </div>
    }
    <div class="center text-center">
      <!--TODO TRANSLATION to store when prototype will be done-->
      <span>{{ 'corpus.import_corpus.informations' | translate }}</span><br>
      <!--my corpus-->
      <button mat-raised-button class="save-button mat-accent"
      (click)="openCorpus(true) ">{{'corpus.title.user' | translate}}</button>
      <!--corpus géneral-->
      <button mat-raised-button class="save-button mat-accent"
        (click)="openCorpus(false) ">{{'corpus.title.generic' | translate}}
      </button>
      <!--file thumbnail corpus title-->
      @if (thumbnail) {
        <div class="center text-center">
          <em><small> {{ thumbnail?.title | translate}}</small></em>
        </div>
      }
    </div>
  }
  <!--upload local pdf-->
  @if (displayField('files')) {
    <div class="mat-form-field mat-form-field-wrapper mat-form-field-infix w-100-p">
      <span class="mat-form-field-label-wrapper">
        <label class="mat-form-field-empty mat-form-field-label">
          {{ 'generic.fileUpload' | translate }}
        </label>
      </span>
    </div>
    <div class="center text-center">
      <span>{{ 'corpus.import_url.informations' | translate }}</span><br>
      <em><small>{{ 'corpus.import_url.details' | translate }} pdf</small></em>
      <ngx-file-drop (onFileDrop)="dropped($event, fileType.document)">
        <!--                    TODO Déprécié customstyle="upload-dragndrop"-->
        <!--                    TODO Déprécié headertext="{{ 'corpus.upload_dragndrop_message' | translate }}"-->
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <button mat-raised-button class="add-file-button" (click)="openFileSelector()"
            aria-label="Add file">
            <span>{{ 'generic.browse' | translate }}</span>
          </button>
        </ng-template>
      </ngx-file-drop>
    </div>
    <div class="file-uploader">
      <input hidden type="file" accept="application/pdf" #fileDocInput
        data-e2e="edit-lesson-doc-upload"
        (change)="onFileChanged($event, fileType.document)" id="docToUpload"/>
      </div>
      <!--file pdf name-->
      <div class="center text-center">
        <em><small> {{ currentDocument | translate}}</small></em>
      </div>
      <!--alert not supported format-->
      @if (!isFileFormatDocumentAllowed) {
        <div>
          <span class="mat-error">{{'activities.document.format' | translate}}</span>
        </div>
      }
    }
  } @else {
    <div mat-dialog-content>
      <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close()" class="save-button mat-accent"
    [disabled]="entityForm?.invalid || isLoading" aria-label="SAVE">
    {{ 'generic.save' | translate }}
  </button>
</mat-dialog-actions>